import sanitizeHtml from 'sanitize-html';

export function getSanitizedMessage(message: string): string {
    return sanitizeHtml(message).replace(/&amp;|javascript|http|https/gi, '')
}
